import React from "react";
import { Route } from "react-router-dom";
import Dashboard from "../pages/admin/pages/dashboard";
import Users from "../pages/admin/pages/users";
import Policy from "../pages/admin/pages/policy";
import AddPolicy from "../pages/admin/pages/addPolicy";
import AddArtworkDetails from "../pages/admin/pages/addArtwork";
import ArtworkAll from "../pages/admin/pages/artworkAll";
import ViewArtworkDetails from "../pages/admin/pages/viewArtworkDetails";
import Subject from "../pages/admin/pages/subject";
import AddSubject from "../pages/admin/pages/addSubject";
import Styles from "../pages/admin/pages/styles";
import AddStyles from "../pages/admin/pages/addStyles";
import Surface from "../pages/admin/pages/surface";
import Medium from "../pages/admin/pages/medium";
import Wishlistdata from "../pages/admin/pages/wishlistdata";
import CartData from "../pages/admin/pages/cart";
import OrderList from "../pages/admin/pages/orders";
import OrderDetails from "../pages/admin/pages/orderDetails";
import VideoPanel from "../pages/admin/pages/videos-panel";
import Currency from "../pages/admin/pages/currency";
import AddProfileArtist from "../pages/admin/pages/addProfileArtist";
import AddProfileUser from "../pages/admin/pages/addProfileUser";
import UploadArtwork from "../pages/admin/pages/uploadArtwork";
import InventoryAll from "../pages/admin/pages/inventoryAll";
import AddInventory from "../pages/admin/pages/addInventory";
import ViewInventoryDetails from "../pages/admin/pages/viewInventoryDetails";
import Exhibition from "../pages/admin/pages/exhibition";
import AddExhibition from "../pages/admin/pages/addExhibition";
import AddExhibitionArtwork from "../pages/admin/pages/addExhibitionArtwork";
import ViewExhibition from "../pages/admin/pages/viewExhibition";
import MailerCustom from "../pages/admin/pages/mailerCustom";
import ShippingCost from "../pages/admin/pages/shippingCost";
import PriceRequest from "../pages/admin/pages/priceRequest";
import ContactUs from "../pages/admin/pages/contactUs";
import BlogAll from "../pages/admin/pages/blogAll";
import AddBlog from "../pages/admin/pages/addBlog";

// Add other admin-specific imports...

const AdminRoutes = () => {
  return (
    <>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/addPolicy" element={<AddPolicy />} />
        <Route path="/addPolicy/:id" element={<AddPolicy />} />
        <Route path="/addArtwork" element={<AddArtworkDetails />} />
        <Route path="/addArtwork/:id" element={<AddArtworkDetails />} />
        <Route path="/artworkAll" element={<ArtworkAll />} />
        <Route path="/viewArtworkDetails/:id" element={<ViewArtworkDetails />} />
        <Route path="/subject" element={<Subject />} />
        <Route path="/addSubject" element={<AddSubject />} />
        <Route path="/addSubject/:id" element={<AddSubject />} />
        <Route path="/styles" element={<Styles />} />
        <Route path="/addStyles" element={<AddStyles />} />
        <Route path="/addStyles/:id" element={<AddStyles />} />
        <Route path="/surface" element={<Surface />} />
        <Route path="/medium" element={<Medium />} />
        <Route path="/Wishlistdata" element={<Wishlistdata />} />
        <Route path="/cart" element={<CartData />} />
        <Route path="/orders" element={<OrderList />} />
        <Route path="/orderDetails/:id" element={<OrderDetails />} />
        <Route path="/videos-panel" element={<VideoPanel />} />
        <Route path="/currency" element={<Currency />} />
        <Route path="/addProfileArtist/:id" element={<AddProfileArtist />} />
        <Route path="/addProfileUser/:id" element={<AddProfileUser />} />
        <Route path="/uploadArtwork/:id" element={<UploadArtwork />} />
        <Route path="/inventoryAll" element={<InventoryAll />} />
        <Route path="/addInventory" element={<AddInventory />} />
        <Route path="/addInventory/:id" element={<AddInventory />} />
        <Route path="/viewInventoryDetails/:id" element={<ViewInventoryDetails />} />
        <Route path="/exhibition" element={<Exhibition />} />
        <Route path="/addExhibition" element={<AddExhibition />} />
        <Route path="/addExhibition/:id" element={<AddExhibition />} />
        <Route path="/addExhibitionArtwork/:id" element={<AddExhibitionArtwork />} />
        <Route path="/viewExhibition/:id" element={<ViewExhibition />} />
        <Route path="/mailerCustom" element={<MailerCustom/>} />
        <Route path="/shippingCost" element={<ShippingCost/>} />
        <Route path="/priceRequest" element={<PriceRequest/>} />
        <Route path="/contactUs" element={<ContactUs/>} />
        <Route path="/blogAll" element={<BlogAll />} />
        <Route path="/addBlog" element={< AddBlog />} />

      {/* Add other admin routes here */}
    </>
  );
};

export default AdminRoutes;
